import React from "react";

import {  Select, Space } from "antd";
import { audioMessage as message } from "../Common/Notifications/audioMessage";

import "../../Styles/styles-multi-select.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getTeamTestingRadarData,
  setTeamTestingRadarMetrics,
} from "../../store/actions/team.actions";
import {
  getPlayerTestingRadarData,
  setPlayerTestingRadarMetrics,
} from "../../store/actions/player.actions";
import { useEffect } from "react";
import RadarChart from "../Charts/RadarChart";
import { mapRadarData } from "../../mappers/model/RadarChart"
import { get_metric_info_from_identifier } from "../../Utils/chart_utils";



const RadarCharts = ({ type, playerId, metric_type = "testing", chartData }) => {
  const MAX_ITEMS_RADAR_SELECT = 10

  const dispatch = useDispatch();
  const { position, player_group, all_metric_types, info: { team_colors: teamColors} } = useSelector(
    ({ team }) => team
  );
  const {
    radarMetrics,
    testingRadarData: { data },
    testingData: { options },
  } = useSelector((store) => store[type]);

  const convertNameToIdentifier = (nameOfMetrics) => {
    return nameOfMetrics.map((metricName) => {
      return all_metric_types[metric_type]?.find((m) => m.name === metricName)?.unique_identifier || metricName
    })
  }

  useEffect(() => {
    handleChangeMetrics(chartData);
  }, [chartData, position]);

  useEffect(() => {
    if (type == "team") {
      dispatch(getTeamTestingRadarData());
    } else {
      dispatch(getPlayerTestingRadarData());
    }
  }, [playerId])

  function CustomTooltip({ payload, label, active }) {
    if (active && payload !== null && payload.length > 0) {
      return (
        <div className="custom-tooltip">
          <p className="custom-tooltip-item">{`${label}`}</p>
          <p
            className="custom-tooltip-item"
            style={{ color: `#1a53ff` }}
          >{`${"Latest Training"}: ${payload[0].payload.value}`}</p>
          <p
            className="custom-tooltip-item"
            style={{ color: `#00b7c7` }}
          >{`${"All time Max"}: ${payload[0].payload.max}`}</p>
          <p
            className="custom-tooltip-item"
            style={{ color: `#ebdc78` }}
          >{`${"All time Min"}: ${payload[0].payload.min}`}</p>

          <p
            className="custom-tooltip-item"
            style={{ color: `#b30000` }}
          >{`${"Historical Average"}: ${payload[0].payload.average}`}</p>
        </div>
      );
    }
    return null;
  }


  const handleChangeMetrics = async (sel) => {
    if (sel.length > MAX_ITEMS_RADAR_SELECT) {
      message.warning("Max selection of 10 items allowed");
      return
    }

    if (type == "team") {
      dispatch(setTeamTestingRadarMetrics(convertNameToIdentifier(sel).filter((val) => !!val)));
      dispatch(getTeamTestingRadarData());
    } else {
      dispatch(setPlayerTestingRadarMetrics(convertNameToIdentifier(sel).filter((val) => !!val)));
      dispatch(getPlayerTestingRadarData());
    }
  };

  const addCustomInformationToRadarSeries = (data = [], isHistorical = false) => {
    const customizedSeries = data?.map( (datapoint, index) => {

      const scaledPoint = isHistorical ? Number(datapoint?.average_scaled?.toFixed(2)) : Number(datapoint?.value_scaled?.toFixed(2));
      const customDataPoint = {
        y: scaledPoint,
        rawValue: isHistorical ? datapoint?.average : datapoint?.value,
        min: datapoint?.min,
        max: datapoint?.max
      }

      return customDataPoint
    })
    return customizedSeries
  }

  const extractRadarChartData = (data) => {
    if (!data) return;

    const latest = { data: addCustomInformationToRadarSeries(data, false), name: `Latest Training`, pointPlacement: 'on', selected: true}
    const historical = { data: addCustomInformationToRadarSeries(data, true), name: 'Historical Average', pointPlacement: 'on', selected: true, visible: true}
    const xAxis = data?.map( (item) => item.metric) || []
    const tooltip = {
      shared: true,
      formatter: function () {
            const metricLine = `Metric: ${this.x} <br>`
            const lines = this.points.map( point => {
              return `${point?.series?.name || ''}: <strong>${point?.point?.rawValue || ''}</strong> (${point?.point?.y || ''})`
            })
            const minLine = `Min:  <strong>${this.point.min}</strong> <br>`
            const maxLine = `Max:  <strong>${this.point.max}</strong>`
            return metricLine + lines.join('<br>') + '<br>' + minLine + maxLine;
      }
    }
    const radarData = mapRadarData([latest, historical], xAxis, teamColors.all, tooltip)
    if (radarData) {
      radarData.drilldown = {
        //for axis label
                activeAxisLabelStyle: {
                    textDecoration: 'none',
                    fontStyle: 'italic'
                },
        //for datalabel
                activeDataLabelStyle: {
                    textDecoration: 'none',
                    fontStyle: 'italic'
                }
        }
    }

    return radarData;
  }

  return (
    <>
      <Space style={{marginBottom: '2em'}}>
        <div className="site-statistic-demo-card">
          <Space
            direction="vertical"
            style={{
              width: "400px",
              marginRight: "4em"
            }}
          >
            <Select
              className="multiSelect"
              mode="multiple"
              allowClear
              style={{ width: "100%", height: "100%" }}
              placeholder="Please select"
              maxTagCount={4}
              value={
                convertNameToIdentifier([...new Set(radarMetrics)]).map((id) => id.split("-").splice(0, 2).join("-"))
              }
              onChange={handleChangeMetrics}
              optionFilterProp="label"
              options={all_metric_types[metric_type]?.map((metric) => {
                return { value: metric.unique_identifier, label: metric.name };
              })}
            />
          </Space>
        </div>
        {(radarMetrics.length >= 3 && data && data.length > 0) ? (
          <div className="radar-chart-container">
            <RadarChart options={extractRadarChartData(data)} />
          </div>
        ) : (
          <p>Please select 3 metrics</p>
        )}
      </Space>
    </>
  );
};

export { RadarCharts };
